import { Box, Button, OsStack, Theme, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import React from "react";

export default function TermsAcceptance({
  canManage = false,
  handleTermsAccepted,
}: {
  canManage?: boolean;
  handleTermsAccepted: () => void;
}) {
  // This component is used by ClassRecordingContent.ts which is used in both learner app (RecordingPage.tsx) and website (MuxRecordingPage.tsx)
  // The learner app does not support translations, but website does
  const { t } = useTranslation(
    "ui-components-classroom\\classroom\\classRecording\\TermsAcceptance",
  );
  return (
    <Box
      sx={(theme: Theme) => ({
        maxWidth: "1024px",
        backgroundColor: "#f1f2f3",
        textAlign: "center",
        padding: "6rem 3rem",
        [theme.breakpoints.down("md")]: {
          paddingX: "1rem",
        },
      })}
    >
      <OsStack direction="column" spacing={2} alignItems="center">
        <Typography variant="h2">{t`Families’ privacy is of utmost importance`}</Typography>
        <Typography variant="body1">
          {canManage
            ? t`Please confirm that you agree not to share any class recording with anyone,
except for the learners enrolled in the section and their parents:`
            : t`Please confirm that you agree not to share any class recording with anyone:`}
        </Typography>
        <Button
          onClick={handleTermsAccepted}
          data-test-id="recording-agree-button"
        >{t`I agree`}</Button>
      </OsStack>
    </Box>
  );
}
